<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Types" subtitle="Manage the types of badges that can be bought or given." :readonly="$authorised('con/badges/access', 'read')">

		<app-content-head-actions-item text="Create" icon="create" v-on:click="onCreateClick" />
		
		<app-content-head-actions-item text="Delete" icon="delete" :danger="true" :disabled="!selected.length" v-on:click="onDeleteClick" />

	</app-content-head>
	
	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no types found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />

				<app-table-column />
				
				<app-table-column text="Name" />

				<app-table-column align="center" text="Days" />

				<app-table-column align="center" text="Limit" />

				<app-table-column align="center" text="Badges" />

				<app-table-column align="center" text="Items" />

				<app-table-column />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.badge.type.statusName[item.status]" :type="$constants.badge.type.statusTheme[item.status]" :subtext="item.reference" />

					<app-table-cell-colour :colour="item.colour" />

					<app-table-cell-text :text="item.name" />

					<app-table-cell-days :days="references.days" :active="item.days.range" :empty-is-all="!item.days.enabled" />

					<app-table-cell-text align="center" :text="item.limit.amount" v-if="item.limit.enabled" />

					<app-table-cell-icon align="center" icon="unlimited" v-if="!item.limit.enabled" v-tooltip="'Unlimited'" />

					<app-table-cell-text align="center" :text="item.count.badges" />

					<app-table-cell-text align="center" :text="item.count.items" />

					<app-table-cell-select :active="isSelected(item.id)" v-on:click="onSelectToggle(item.id)" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			references: {
				days: []
			},
			layout: '120px 40px auto 200px 120px 120px 120px 40px',
			endpoint: 'convention/badges/types',
			live: 'convention/badges/types',
			edit: 'Convention.Badges.Types.Edit'
		}

	},

	methods: {

		daysText: function(item) {

			if (!item.days.enabled) {

				return 'All'

			} else {

				var ordered = this.$util.copy(item.days.range)
				ordered.sort()

				var text = []

				this.$_.each(ordered, function(day) {

					text.push(this.$moment.unix(this.$convention.start).utc().add(day - 1, 'days').format('ddd'))

				}.bind(this))

				return text.join(', ')

			}

		}

	}

}

</script>

<style scoped>

</style>